import * as THREE from "three";
import {BoxGeometry, Mesh, MeshLambertMaterial, MeshBasicMaterial, TextureLoader} from "three";
import {mergeBufferGeometries} from "three/examples/jsm/utils/BufferGeometryUtils";
// const ThreeBSP = require('tthreebsp')(THREE)

const createFloor = (long,width) => {
    const loader = new THREE.TextureLoader();
    const texture = loader.load('/three/server-room/floor.jpg');
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.magFilter = THREE.NearestFilter;
    const repeats = long / 200;
    texture.repeat.set(repeats, repeats);
    const planeGeo = new THREE.PlaneGeometry(long, width);
    const planeMat = new THREE.MeshPhongMaterial({
        map: texture,
        side: THREE.DoubleSide,
    });
    const floor = new THREE.Mesh(planeGeo, planeMat);//地板
    floor.rotation.x = Math.PI * -0.5;

    const wallHeight = 200;
    const wallDepth = 8;
    const leftWallGeo = new BoxGeometry(width,wallHeight,wallDepth);
    let wallMap = new THREE.TextureLoader().load('/three/server-room/wall.png');
    wallMap.wrapS = THREE.RepeatWrapping;
    wallMap.wrapT = THREE.RepeatWrapping;
    wallMap.repeat.set(10, 2);
    const wallMat = new MeshLambertMaterial({
        color:0xb4d3e7,
        map: wallMap,
    });
    const leftWall = new Mesh(leftWallGeo, wallMat);//左面墙
    leftWall.position.set(-long/2,wallHeight/2,0);
    leftWall.rotateY(Math.PI/2);

    const rightWallGeo = new BoxGeometry(width,wallHeight,wallDepth);
    const rightWall = new Mesh(rightWallGeo, wallMat);//右面墙
    rightWall.position.set(long/2,wallHeight/2,0);
    rightWall.rotateY(Math.PI/2);

    // const frontWallGeo = new BoxGeometry(long,wallHeight,wallDepth);
    // const frontWall = new Mesh(frontWallGeo, wallMat);
    // frontWall.position.set(0,wallHeight/2,width/2);//前面墙

    const backWallGeo = new BoxGeometry(long,wallHeight,wallDepth);
    const backWall = new Mesh(backWallGeo, wallMat);
    backWall.position.set(0,wallHeight/2,-width/2);//后面墙

    const winX = 260,winY = 20,winWidth = 800,winHeight = 160;//窗户模型
    const windowMat = new MeshBasicMaterial({color: 0x0b3bcb, opacity: 0.4, transparent: true,depthWrite:false});
    const windowGeo = new BoxGeometry(winWidth+4,winHeight+4,4);
    const wallWindow = new Mesh(windowGeo, windowMat);
    wallWindow.position.set(-long/2+winWidth/2+winX,winHeight/2+winY,width/2+4);

    const doorX = 1500,doorY = 4,doorWidth = 100,doorHeight = 180;//门
    const doorMat = new MeshBasicMaterial({color:0x000000,opacity: 0.7, transparent: true,depthWrite: false,map: new TextureLoader().load('/three/server-room/door_left.png'),});
    const doorGeo = new BoxGeometry(doorWidth,doorHeight+4,4);
    const door = new Mesh(doorGeo, doorMat);
    door.position.set(-long/2+doorWidth/2+doorX,doorHeight/2+doorY,width/2+4);
    const doorMat2 = new MeshBasicMaterial({color:0x000000,opacity: 0.7, transparent: true,depthWrite: false,map: new TextureLoader().load('/three/server-room/door_right.png'),});
    const doorGeo2 = new BoxGeometry(doorWidth,doorHeight+4,4);
    const door2 = new Mesh(doorGeo2, doorMat2);
    door2.position.set(-long/2+doorWidth/2+doorX+100,doorHeight/2+doorY,width/2+4);

    const pillarMat = new MeshLambertMaterial({color:0xb4d3e7});//柱子材质
    const pillarGeo1 = new BoxGeometry(60,wallHeight+10,60);//4个柱子
    const pillar1 = new Mesh(pillarGeo1, pillarMat);
    pillar1.position.set(-long/2,wallHeight/2,-width/2);
    const pillarGeo2 = new BoxGeometry(60,wallHeight+10,60);
    const pillar2 = new Mesh(pillarGeo2, pillarMat);
    pillar2.position.set(-long/2,wallHeight/2,width/2);
    const pillarGeo3 = new BoxGeometry(60,wallHeight+10,60);
    const pillar3 = new Mesh(pillarGeo3, pillarMat);
    pillar3.position.set(long/2,wallHeight/2,width/2);
    const pillarGeo4 = new BoxGeometry(60,wallHeight+10,60);
    const pillar4 = new Mesh(pillarGeo4, pillarMat);
    pillar4.position.set(long/2,wallHeight/2,-width/2);

    floor.updateMatrix();
    leftWall.updateMatrix();
    rightWall.updateMatrix();
    backWall.updateMatrix();
    pillar1.updateMatrix();
    pillar2.updateMatrix();
    pillar3.updateMatrix();
    pillar4.updateMatrix();
    wallWindow.updateMatrix();
    door.updateMatrix();
    door2.updateMatrix();
    floor.geometry.applyMatrix4(floor.matrix);
    leftWall.geometry.applyMatrix4(leftWall.matrix);
    rightWall.geometry.applyMatrix4(rightWall.matrix);
    backWall.geometry.applyMatrix4(backWall.matrix);
    pillar1.geometry.applyMatrix4(pillar1.matrix);
    pillar2.geometry.applyMatrix4(pillar2.matrix);
    pillar3.geometry.applyMatrix4(pillar3.matrix);
    pillar4.geometry.applyMatrix4(pillar4.matrix);
    wallWindow.geometry.applyMatrix4(wallWindow.matrix);
    door.geometry.applyMatrix4(door.matrix);
    door2.geometry.applyMatrix4(door2.matrix);

    const mergedGeometry = mergeBufferGeometries([
        floor.geometry,
        leftWall.geometry,
        rightWall.geometry,
        backWall.geometry,
        pillar1.geometry,
        pillar2.geometry,
        pillar3.geometry,
        pillar4.geometry,
        wallWindow.geometry,
        door.geometry,
        door2.geometry,
    ], true)
    const room = new Mesh(mergedGeometry, [
        floor.material,
        leftWall.material,
        rightWall.material,
        backWall.material,
        pillar1.material,
        pillar2.material,
        pillar3.material,
        pillar4.material,
        wallWindow.material,
        door.material,
        door2.material,
    ]);
    room.receiveShadow = true;

    const squareShape = new THREE.Shape();
    squareShape.moveTo( 0, 0 );
    squareShape.lineTo( 0, wallHeight);
    squareShape.lineTo( long, wallHeight);
    squareShape.lineTo( long, 0 );
    squareShape.lineTo( 0, 0 );

    const windowPath = new THREE.Path();
    windowPath.moveTo( winX, winY );
    windowPath.lineTo( winX, wallHeight - winY);
    windowPath.lineTo( winX+winWidth, wallHeight - winY);
    windowPath.lineTo( winX+winWidth, winY );

    const doorPath = new THREE.Path();
    doorPath.moveTo( doorX, doorY );
    doorPath.lineTo( doorX, wallHeight - 15);
    doorPath.lineTo( doorX + doorWidth+100, wallHeight - 15);
    doorPath.lineTo( doorX + doorWidth+100 , doorY );

    squareShape.holes.push( windowPath,doorPath );// 挖洞
    const extrudeSettings = {depth: wallDepth, bevelEnabled: true, bevelSegments: 0, steps: 1, bevelSize: 0, bevelThickness: 0};
    const frontWallGeometry = new THREE.ExtrudeBufferGeometry(squareShape, extrudeSettings);
    const frontWall = new THREE.Mesh(frontWallGeometry,wallMat);
    frontWall.position.set(-long/2,0,width/2);

    const group = new THREE.Group();
    group.add(room,frontWall)
    return group;
}
export {createFloor}
